import { format } from "date-fns";
export const dateFormatSlashing = "yyyy/MM/dd";
export default function displaySlashingDate(date = new Date()) {
    return format(date, dateFormatSlashing);
}